// extracted by mini-css-extract-plugin
export var copyContainer = "style-module--copyContainer--bb984";
export var media = "style-module--media--b8c5a";
export var mediaContainer = "style-module--mediaContainer--2d2bd";
export var subline = "style-module--subline--bc0b9";
export var title = "style-module--title--da1a2";